// export const environment = {
//   production: true,
//   //baseAPIUrl: 'https://primez.insure.digital/',
//   // baseAPIUrl:'https://demo-api-primez.insure.digital/',
//   // baseAPIUrl : 'https://primez-uat-api.azurewebsites.net/',
//   //baseAPIUrl : 'https://uat-api-primez.insure.digital/',
//   // authAPIURL:'https://uat-uad-primez.insure.digital/',
//   // productConfigBaseUrl : 'https://demo-prodconfig-api-primez.insure.digital/',
//   // baseAPIUrl: 'https://uaedemo-finance-primez.insure.digital/',
//   // authAPIURL: 'https://uaedemo-uad-api-primez.insure.digital/',
//   // productConfigBaseUrl: 'https://uaedemo-prodconfig-api-primez.insure.digital/',
//   // baseAPIUrl: 'https://primez.insure.digital/',
//   // authAPIURL:'https://uad-toggle-api-primez.insure.digital/',
//   // productConfigBaseUrl : 'https://uat-productConfig-toggle-api-primez.insure.digital/',
//   // baseAPIUrl: 'https://uaedemo-finance-primez.insure.digital/',
//   // authAPIURL:'https://uaedemo-uad-api-primez.insure.digital/',
//   // productConfigBaseUrl : 'https://uaedemo-prodconfig-api-primez.insure.digital/',
//   mockAPIProductConfig: "https://apim.development.swiftant.com/",
//   googleMapKey: 'AIzaSyAxdzR3_Eqg5DSNslA6FvsBvXbwhx8VG7g', //'AIzaSyDywmyAriryGz7BKtW6igwAdOMALDYKZLk',
//   azureMapsKey: 'bVLE-0X6_4fJ5AR_1knIm5FQ5aG6oRtollKfqBLyhkk',
//   orgAppId: 6170,
//   orgGroupID:"D1B36050-4040-48E9-BD75-5C41CCA96371",
//   // baseAPIUrl: 'https://development-core-primez-api.insure.digital/',
//   // authAPIURL: 'https://uat-uad-primez.insure.digital/',
//   // productConfigBaseUrl : 'https://development-core-primez-api.insure.digital/'

//   authAPIURL: 'https://dev-afrisure-uad-api.insure.digital/',
//   productConfigBaseUrl : 'https://dev-afrisure-core-api.insure.digital/',
//   baseAPIUrl: 'https://dev-afrisure-core-api.insure.digital/',
//   coreBaseUrl:'https://dev-afrisure-api.insure.digital/',

// };

// changes by gowtham for prod environment
export const environment = {
  production: false,
  azureMapsKey: 'bVLE-0X6_4fJ5AR_1knIm5FQ5aG6oRtollKfqBLyhkk',
  mockAPIProductConfig: "https://apim.development.swiftant.com/",
  orgAppId: 6240,
  orgGroupID: "f0fcda38-6416-4c6a-8c71-05c18cb520f0",
  googleMapKey: 'AIzaSyAxdzR3_Eqg5DSNslA6FvsBvXbwhx8VG7g',
  coreBaseUrl: 'https://nyala-afrisure.insure.digital/',
  authAPIURL: 'https://nyala-common-uad.insure.digital/',
  productConfigBaseUrl: 'https://nyala-afrisure-product.insure.digital/',
  baseAPIUrl: 'https://nyala-afrisure-erp.insure.digital/',
};

